import React from "react";
import {
    Edit,
    EditProps,
    SimpleForm,
    TextInput,
    NumberInput,
    BooleanInput,
    required,
    ImageField,
    ImageInput
} from 'react-admin';
import { makeStyles } from "@material-ui/core";
import { useTranslate } from "react-admin";
import UploadImages from "../products/UploadImages";
const useStyles = makeStyles(theme => ({
    description: {
        width: 544,
    }
  }));

const CategoryTitle = (props: any) => {
    const { record } = props;
    const translate = useTranslate();
    return record ? (
        <span>
            {translate('resources.categories.name', { smart_count: 1 })}
        </span>
    ) : null;
};

const CategoryEdit = (props: EditProps) => {
 
 const classes = useStyles();

 return(
    <Edit  title={<CategoryTitle/>} {...props}>
        <SimpleForm>
            <TextInput
                autoFocus
                source="name_en"
                validate={required()}
            />
            <TextInput
                autoFocus
                source="name_ar"
                validate={required()}
            />
            {/* <UploadImages sourceName="featured" /> */}
            <UploadImages sourceName="featured_image1" multiple={false} />
            <BooleanInput  source="is_featured" />
            <BooleanInput source="active" />       
        </SimpleForm>   
    </Edit>
   )
}

export default CategoryEdit;